import { __decorate } from "tslib";
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
let WorkerPageStore = class WorkerPageStore extends VuexModule {
    workerData = null;
    branchStateData = null;
    hubStateData = null;
    companyStateData = null;
    workerUpdateData = null;
    addressUpdateData = null;
    isUpdateAddressShow = false;
    workerScheduleData = null;
    scheduleId = null;
    workerIds = [];
    workerInvitationIds = [];
    WORKER_DATA(data) {
        this.workerData = data;
    }
    UPDATE_ADDRESS_POPUP_SHOW(value) {
        this.isUpdateAddressShow = value;
    }
    setWorkerScheduleData(data) {
        this.workerScheduleData = data;
    }
    setScheduleId(data) {
        this.scheduleId = data;
    }
    setBranchData(data) {
        this.branchStateData = data;
    }
    setHubData(data) {
        this.hubStateData = data;
    }
    setCompanyData(data) {
        this.companyStateData = data;
    }
    setCompanyUserData(data) {
        if (this.companyStateData) {
            // @ts-ignore-next-line
            this.companyStateData.technicians = data;
        }
    }
    setWorkerIds(data) {
        this.workerIds = [...this.workerIds, data];
    }
    setWorkerInvitationIds(data) {
        this.workerInvitationIds = this.workerInvitationIds.includes(data) ? this.workerInvitationIds.filter(e => e !== data) : [...this.workerInvitationIds, data];
    }
    WORKER_UPDATE_DATA(data) {
        this.workerUpdateData = data;
    }
    ADDRESS_UPDATE_DATA(data) {
        this.addressUpdateData = data;
    }
    storeWorkerData(payload) {
        return payload;
    }
    storeWorkerScheduleData(payload) {
        return payload;
    }
    storeBranchData(payload) {
        return payload;
    }
    storeHubData(payload) {
        return payload;
    }
    storeCompanyData(payload) {
        return payload;
    }
    storeWorkerUpdateData(payload) {
        return payload;
    }
    get workerIdsGetter() {
        return this.workerIds;
    }
    get workerInvitationIdsGetter() {
        return this.workerInvitationIds;
    }
};
__decorate([
    Mutation
], WorkerPageStore.prototype, "WORKER_DATA", null);
__decorate([
    Mutation
], WorkerPageStore.prototype, "UPDATE_ADDRESS_POPUP_SHOW", null);
__decorate([
    Mutation
], WorkerPageStore.prototype, "setWorkerScheduleData", null);
__decorate([
    Mutation
], WorkerPageStore.prototype, "setScheduleId", null);
__decorate([
    Mutation
], WorkerPageStore.prototype, "setBranchData", null);
__decorate([
    Mutation
], WorkerPageStore.prototype, "setHubData", null);
__decorate([
    Mutation
], WorkerPageStore.prototype, "setCompanyData", null);
__decorate([
    Mutation
], WorkerPageStore.prototype, "setCompanyUserData", null);
__decorate([
    Mutation
], WorkerPageStore.prototype, "setWorkerIds", null);
__decorate([
    Mutation
], WorkerPageStore.prototype, "setWorkerInvitationIds", null);
__decorate([
    Mutation
], WorkerPageStore.prototype, "WORKER_UPDATE_DATA", null);
__decorate([
    Mutation
], WorkerPageStore.prototype, "ADDRESS_UPDATE_DATA", null);
__decorate([
    Action({ commit: 'WORKER_DATA' })
], WorkerPageStore.prototype, "storeWorkerData", null);
__decorate([
    Action({ commit: 'setWorkerScheduleData' })
], WorkerPageStore.prototype, "storeWorkerScheduleData", null);
__decorate([
    Action({ commit: 'setBranchData' })
], WorkerPageStore.prototype, "storeBranchData", null);
__decorate([
    Action({ commit: 'setHubData' })
], WorkerPageStore.prototype, "storeHubData", null);
__decorate([
    Action({ commit: 'setCompanyData' })
], WorkerPageStore.prototype, "storeCompanyData", null);
__decorate([
    Action({ commit: 'WORKER_UPDATE_DATA' })
], WorkerPageStore.prototype, "storeWorkerUpdateData", null);
WorkerPageStore = __decorate([
    Module({
        namespaced: true,
    })
], WorkerPageStore);
export default WorkerPageStore;
